import { render, staticRenderFns } from "./GroupCtrlCompoent.vue?vue&type=template&id=a3b5702c&"
import script from "./GroupCtrlCompoent.vue?vue&type=script&lang=ts&"
export * from "./GroupCtrlCompoent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports